
import React from 'react';
import BottomNavigation from './BottomNavigation';
import Header from './Header';
import ViewToggle from './ViewToggle';
import { useIsMobile } from '../../hooks/use-mobile';
import { useActingAsAdmin } from '../../hooks/useActingAsAdmin';

interface MainLayoutProps {
  children: React.ReactNode;
  title: string;
  showBackButton?: boolean;
  rightAction?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  title,
  showBackButton = false,
  rightAction
}) => {
  const isMobile = useIsMobile();
  const actingAsAdmin = useActingAsAdmin();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header title={title} showBackButton={showBackButton} rightAction={rightAction} />
      <main className="max-w-screen-sm mx-auto pb-20 px-0 pt-4">
        {children}
      </main>
      {isMobile && !actingAsAdmin && <BottomNavigation />}
      <ViewToggle />
    </div>
  );
};

export default MainLayout;
